export const storageInviteToken = 'rosterInviteToken';
export const storageProfileAccessToken = 'profileAccessToken';
export const storageForwardedRequestTokenData = 'forwardedRequestTokenData';
export const CCS_CONTACT_LINK = 'https://support.castingnetworks.com/hc/en-us/requests/new';
export const CLAIM_ACCOUNT_MODAL_STORAGE_KEY = 'doNotShowClaimAccountModal';
export const CORP_LINK = 'https://corp.castingnetworks.com/regional-signup';
